import { Box } from '@web/components/atoms/Layout'
import type { Video as VideoProps } from '@web/graphql-components'
import { ComponentLayout } from '@web/components/page-components/default'
import { DESKTOP_CONTAINER_QUERY, MOBILE_CONTAINER_QUERY } from '@web/components/page-components/utils'

const getAspectRatioStyles = (aspectRatio?: string) => {
  const isVertical = aspectRatio === ComponentLayout.Vertical

  return {
    aspectRatio: isVertical ? '9 / 16' : '16 / 9',
    maxWidth: isVertical ? '360px' : '100%',
    marginInline: isVertical ? 'auto' : undefined,
  }
}

const Video = ({ title, url, styles, mobileStyles }: VideoProps) => {
  return url ? (
    <Box
      css={{
        [MOBILE_CONTAINER_QUERY]: {
          p: mobileStyles?.padding ?? 0,
        },
        [DESKTOP_CONTAINER_QUERY]: {
          p: styles?.padding ?? 0,
        },
      }}
      width="100%"
      className="c-component-wrapper"
    >
      <Box
        position="relative"
        width="100%"
        css={{
          '& iframe': {
            [MOBILE_CONTAINER_QUERY]: getAspectRatioStyles(mobileStyles?.aspectRatio),
            [DESKTOP_CONTAINER_QUERY]: getAspectRatioStyles(styles?.aspectRatio),
            width: '100%',
            height: '100%',
            border: 0,
          },
        }}
      >
        <iframe src={url} title={title || ''} allowFullScreen={true} referrerPolicy="strict-origin-when-cross-origin" />
      </Box>
    </Box>
  ) : null
}

export default Video
